var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-12 control-section"},[_c('div',{staticClass:"tree-control-wrapper"},[_c('ejs-treeview',{ref:"neTreeForCreate",attrs:{"id":"neTreeForCreate","fields":_vm.fields,"nodeSelected":_vm.nodeSelectedOfNeTreeForCreate}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }